<template>
  <div>
    <v-app :is="layout" :dir="isRTL($i18n.locale) ? 'rtl' : 'ltr'">
      <v-main>
        <router-view></router-view>
      </v-main>
    </v-app>
    <ErrorDisplayDialog :dialogControls="dialogControls" />
  </div>
</template>

<script>
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
// Add the Firebase products that you want to use
import "firebase/messaging";
import store from "@/store";
import uuid4 from "uuid4";
import { isRTL } from "@/framework/utilities/isRTL";
import { isSamoon } from "@/framework/utilities/isSamoon";
import { isEmpty } from "@/framework/utilities/isEmpty";
import { checkExistInquiry } from "@/modules/staff/services/inquiry";
import { ErrorService } from "@/framework/errors/ErrorService";
import { AuthService } from "@/framework/api/AuthService";
import ErrorDisplayDialog from "@/framework/components/common/ErrorDisplayDialog";

const noHeaderLayout = "no-header";

export default {
  name: "App",
  components: {
    ErrorDisplayDialog,
  },
  data() {
    return {
      title: "Kotozna In-room",
      drawerToggle: false,
      deferredPrompt: null,
      dialogControls: {
        dialog: false,
        title: "",
        text: "",
        errorType: "",
        errorMessage: "",
      },
    };
  },
  methods: {
    updatePushNotificationToken: async function (token, deviceId) {
      const res = await new AuthService().updateDeviceToken(token, deviceId);
      if (res.isErr()) {
        await new ErrorService().handleError(res.error);
      }
    },
    removePushNotificationToken: async function (deviceId) {
      const res = await new AuthService().removeDeviceToken(deviceId);
      if (res.isErr()) {
        await new ErrorService().handleError(res.error);
      }
    },
    isRTL: function (lang) {
      const isRTLcheck = isRTL(lang);
      this.$vuetify.rtl = isRTLcheck;
      return isRTLcheck;
    },
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || noHeaderLayout) + "-layout";
    },
    errorDialogControls() {
      return store.getters.getDialogControls;
    },
  },
  watch: {
    $route: async function (to, from) {
      // サインイン時(signinページから会話一覧ページへの遷移への場合)、
      // アカウント移行時(migrationページから会話一覧ページへの遷移への場合)、
      // notification tokenを更新
      if (
        (from.path.search(/\/signin/) > 0 && to.path.search(/\/conversations/) > 0) ||
        (from.path.search(/\/migration/) > 0 && to.path.search(/\/conversations/) > 0)
      ) {
        console.log("sign in / migrate");

        // likelihood is we don't have the device ID yet (at login, essentially), so gen/save it if needed
        let deviceId = store.getters.deviceId;
        if (!deviceId) {
          deviceId = uuid4();
          store.commit("SET_DEVICE_ID", deviceId);
        }

        await this.removePushNotificationToken(deviceId);
        const messaging = firebase.messaging();
        messaging
          .getToken()
          .then(async (currentToken) => {
            if (currentToken) {
              console.log("Token is " + currentToken);
              await this.updatePushNotificationToken(currentToken, deviceId);
            } else {
              // Show permission request.
              console.log("No Instance ID token available. Request permission to generate one.");
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
          });
      }
    },
    errorDialogControls: function (newVal, oldVal) {
      this.dialogControls = newVal;
    },
  },
  created: async function () {
    console.log("App - created()");
    // TODO: Replace the following with your app's Firebase project configuration
    const firebaseConfig = {
      apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "",
      authDomain: "ktzn-chat-fe.firebaseapp.com",
      databaseURL: "https://ktzn-chat-fe.firebaseio.com",
      projectId: "ktzn-chat-fe",
      storageBucket: "",
      messagingSenderId: "12989888040",
      appId: "1:12989888040:web:ce1647a91344bba7",
    };
    // Initialize Firebase
    const project = firebase.initializeApp(firebaseConfig);
    console.log(project);

    if (firebase.messaging.isSupported()) {
      const messaging = firebase.messaging();
      // Add the public key generated from the console here.
      messaging.usePublicVapidKey(
        "BCqdI12WMWhv3qzVbY3EjeZ4VBGuXfb-r2fwtAakcEeGISY9HFrS3fvc_gfKurx9vc2O27_rYvW4fGRp3rjjSF4"
      );

      const checkTokenForMessaging = () => {
        messaging
          .getToken()
          .then(async (currentToken) => {
            if (currentToken) {
              // sendTokenToServer(currentToken);
              // updateUIForPushEnabled(currentToken);
              console.log("Token is " + currentToken);
              const deviceId = store.getters.deviceId;
              if (deviceId) {
                await this.updatePushNotificationToken(currentToken, deviceId);
              }
            } else {
              // Show permission request.
              console.log("No Instance ID token available. Request permission to generate one.");
              // Show permission UI.
              // updateUIForPushPermissionRequired();
              // setTokenSentToServer(false);
            }
          })
          .catch((err) => {
            console.log("An error occurred while retrieving token. ", err);
            // showToken('Error retrieving Instance ID token. ', err);
            // setTokenSentToServer(false);
          });
      };

      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          // TODO(developer): Retrieve an Instance ID token for use with FCM.
          // ...
          // Get Instance ID token. Initially this makes a network call, once retrieved
          // subsequent calls to getToken will return from cache.
          console.warn("Notification permission granted.");
          checkTokenForMessaging();
        } else {
          console.warn("Notifications blocked. Please enable them in your browser.");
        }
      });

      // Callback fired if Instance ID token is updated.
      messaging.onTokenRefresh(() => {
        messaging
          .getToken()
          .then(async (refreshedToken) => {
            console.log("Token refreshed. Token is " + refreshedToken);
            await this.updatePushNotificationToken(refreshedToken, store.getters.deviceId);
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            // setTokenSentToServer(false);
            // // Send Instance ID token to app server.
            // sendTokenToServer(refreshedToken);
            // ...
          })
          .catch((err) => {
            console.log("Unable to retrieve refreshed token ", err);
          });
      });
      messaging.onMessage((payload) => {
        console.log("Message received. ", payload);
        const nowRoute = this.$route.path;
        if (payload.data.inquiry_id) {
          const user = store.getters.user;
          if (!isEmpty(user) && user.langCd && user.sandboxType !== "sandbox") {
            checkExistInquiry(user.langCd);
          }
        }
      });
    } else {
      console.log("Firebase messaging is not supported!!");
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(function (registration) {
          console.warn(">>> Service Worker registered with scope:", registration.scope);
        })
        .catch(function (error) {
          console.error("Service Worker registration failed:", error);
        });
    }
  },
  mounted: function () {
    console.log("App - mounted()");

    // incredibly ugly way of finding/replacing the default faivcon path that the PWA project defaults to
    const favicon16 = document.querySelector("link[sizes~='16x16']");
    const favicon32 = document.querySelector("link[sizes~='32x32']");
    var faviconIcon = "ktznFavicon";
    // gosh golly, hope no false positives show up in the URL, given how many two-letter codes there are in the domain
    if (isSamoon()) {
      faviconIcon = "samoonFavicon";
    }
    if (favicon16) favicon16.href = favicon16.href.replace("favicon", faviconIcon);
    if (favicon32) favicon32.href = favicon32.href.replace("favicon", faviconIcon);

    window.addEventListener("beforeinstallprompt", (e) => {
      console.log("add listner - beforeinstallprompt");
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (!localStorage.wasShowdedPrompt) {
        // 一度表示されたらもう表示しないようにする
        this.deferredPrompt = e;
      }
    });
    window.addEventListener("appinstalled", (e) => {
      console.log("a2hs installed");
      this.deferredPrompt = null;
    });

    window.addEventListener("push", function (event) {
      console.warn("---------->>>>>>> Raw push event:", JSON.stringify(event));
    });

    //Reload Browser 2 times a day 3 AM and 4 AM
    // refreshBrowserForToken(3, 0, 0);
    // refreshBrowserForToken(4, 0, 0);
  },
  destroyed: function () {
    console.log("App - destoryed()");
    window.removeEventListener("beforeinstallprompt", (e) => {
      console.log("delete listner - beforeinstallprompt");
    });
    window.removeEventListener("appinstalled", (e) => {});
  },
};
</script>

<style>
@import "./assets/sass/common.scss";

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

html {
  box-sizing: border-box;
}
</style>
